import { DictionariesCreatePage } from 'features/dictionaries/components/DictionariesCreatePage'
import { DictionaryType } from 'features/dictionaries/types'

export const DictionariesEquipmentCreatePage = () => {
  return <DictionariesCreatePage type={DictionaryType.Equipment} />
}
